import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { StandardMobileHeader } from 'components/app-header/mobile-header';
import { LocationEmptyState } from 'components/location-empty-state';
import { useIsNativeTabBarEnabled } from 'hooks/use-is-native-tab-bar-enabled';
import LoyaltyInRestaurantRedemption from 'pages/loyalty/loyalty-in-restaurant-redemption/loyalty-in-restaurant-redemption';
import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

export default function MyCodeRoute() {
  const { noStoreSelected } = useStoreRequired(true, undefined, routes.myCode);
  const isNativeTabBarEnabled = useIsNativeTabBarEnabled();

  const content = noStoreSelected ? (
    <LocationEmptyState title={t('emptyMyCodeHeading')} message={t('emptyMenuMessage')} />
  ) : (
    <LoyaltyInRestaurantRedemption />
  );

  if (isNativeTabBarEnabled) {
    return (
      <>
        <StandardMobileHeader useNativeTabsRootSafeAreaInset />
        {content}
      </>
    );
  }

  return content;
}
